import { axiosClient } from '../../library/Service/axiosClient';
import { REPORT_CONFIG } from '../admin/reports/report-config';
import pageConfig from './PageConfigList.json';
import pageConfigReport from './PageConfigReport.json';

class ProgramLisingService {
    static pageLoader(params: any): Promise<any> {
        const state: any = {};
        const searchCriteria = ProgramLisingService.getDefaultSearchCriteria();
        const isReportMode = params.pageName === 'program-report';

        const initialFetches: Promise<any>[] = [this.getPageConfig(params.pageName)];
        if (!isReportMode) {
            initialFetches.push(this.search(searchCriteria, params.pageName));
        }

        return Promise.all(initialFetches).then((values) => {
            state.formConfig = values[0];
            state.data = {
                alumniList: isReportMode ? [] : (values[1]?.data ?? []),
                searchCriteria: isReportMode
                    ? searchCriteria
                    : { ...searchCriteria, schoolId: sessionStorage.getItem('user-school-id') },
                reportConfig: REPORT_CONFIG[params.pageName],
            };
            state.routeInfo = params;
            state.internal = { gridState: {} };
            return Promise.resolve(state);
        });
    }

    static search(searchCriteria: any, pageName: string): any {
        const config = REPORT_CONFIG[pageName];
        const payload = ProgramLisingService.sanitizeSearchCriteria(searchCriteria,);
        return axiosClient().post(`${process.env.REACT_APP_REPORTS_SERVER}/${config.SEARCH_API}`, payload);
    }

    static getPageConfig(pageName?: string) {
        if (pageName === 'program-report') return Promise.resolve(pageConfigReport);
        return Promise.resolve(pageConfig);
    }

    static sanitizeSearchCriteria(searchCriteria: any) {
        return searchCriteria;
    }

    static getDefaultSearchCriteria(): any {
        return {
            instituteId:[],
            programType: [],
            programMode:[],
            courseEligibility:[],
            departId:[],
            subDepartmentId:[],
            programDuration:[],
        };
    }
}

export default ProgramLisingService;
